"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageLink = exports.useLinkStyles = void 0;
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
exports.useLinkStyles = core_1.makeStyles(function (theme) {
    return {
        link: {
            color: theme.variables.palette.crypto.linkColor,
        },
    };
});
exports.MessageLink = function () {
    var chunks = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        chunks[_i] = arguments[_i];
    }
    var classes = exports.useLinkStyles();
    return (react_1.default.createElement(core_1.Link, { href: "https://www.cryptopro.ru/products/cades/plugin", target: "_blank", underline: "always", style: { display: 'inline' }, className: classes.link, id: "add-signature-cryptopro-link" }, chunks));
};
